const _c0 = ["pMenuItemContent", ""];
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = () => ({
  exact: false
});
const _c3 = a0 => ({
  item: a0
});
function MenuItemContent_ng_container_1_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuItemContent_ng_container_1_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtemplate(1, MenuItemContent_ng_container_1_a_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const itemContent_r2 = i0.ɵɵreference(4);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("itemLink"), ctx_r0.item == null ? null : ctx_r0.item.linkClass));
    i0.ɵɵproperty("ngStyle", ctx_r0.item == null ? null : ctx_r0.item.linkStyle)("target", ctx_r0.item.target)("pBind", ctx_r0.getPTOptions("itemLink"));
    i0.ɵɵattribute("title", ctx_r0.item.title)("href", ctx_r0.item.url || null, i0.ɵɵsanitizeUrl)("data-automationid", ctx_r0.item.automationId)("tabindex", -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemContent_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c1, ctx_r0.item));
  }
}
function MenuItemContent_ng_container_1_a_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuItemContent_ng_container_1_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtemplate(1, MenuItemContent_ng_container_1_a_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const itemContent_r2 = i0.ɵɵreference(4);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("itemLink"), ctx_r0.item == null ? null : ctx_r0.item.linkClass));
    i0.ɵɵproperty("routerLink", ctx_r0.item.routerLink)("queryParams", ctx_r0.item.queryParams)("routerLinkActiveOptions", ctx_r0.item.routerLinkActiveOptions || i0.ɵɵpureFunction0(19, _c2))("ngStyle", ctx_r0.item == null ? null : ctx_r0.item.linkStyle)("target", ctx_r0.item.target)("fragment", ctx_r0.item.fragment)("queryParamsHandling", ctx_r0.item.queryParamsHandling)("preserveFragment", ctx_r0.item.preserveFragment)("skipLocationChange", ctx_r0.item.skipLocationChange)("replaceUrl", ctx_r0.item.replaceUrl)("state", ctx_r0.item.state)("pBind", ctx_r0.getPTOptions("itemLink"));
    i0.ɵɵattribute("data-automationid", ctx_r0.item.automationId)("tabindex", -1)("title", ctx_r0.item.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemContent_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(20, _c1, ctx_r0.item));
  }
}
function MenuItemContent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MenuItemContent_ng_container_1_a_1_Template, 2, 13, "a", 4)(2, MenuItemContent_ng_container_1_a_2_Template, 2, 22, "a", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.item == null ? null : ctx_r0.item.routerLink));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item == null ? null : ctx_r0.item.routerLink);
  }
}
function MenuItemContent_ng_container_2_1_ng_template_0_Template(rf, ctx) {}
function MenuItemContent_ng_container_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemContent_ng_container_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function MenuItemContent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MenuItemContent_ng_container_2_1_Template, 1, 0, null, 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx_r0.item));
  }
}
function MenuItemContent_ng_template_3_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("itemIcon", i0.ɵɵpureFunction1(5, _c3, ctx_r0.item)), ctx_r0.item.iconClass));
    i0.ɵɵproperty("pBind", ctx_r0.getPTOptions("itemIcon"))("ngStyle", ctx_r0.item.iconStyle);
    i0.ɵɵattribute("data-pc-section", "itemicon");
  }
}
function MenuItemContent_ng_template_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("itemLabel"), ctx_r0.item.labelClass));
    i0.ɵɵproperty("ngStyle", ctx_r0.item.labelStyle)("pBind", ctx_r0.getPTOptions("itemLabel"));
    i0.ɵɵattribute("data-pc-section", "itemlabel");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item.label);
  }
}
function MenuItemContent_ng_template_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("itemLabel"), ctx_r0.item.labelClass));
    i0.ɵɵproperty("ngStyle", ctx_r0.item.labelStyle)("innerHTML", i0.ɵɵpipeBind1(1, 6, ctx_r0.item.label), i0.ɵɵsanitizeHtml)("pBind", ctx_r0.getPTOptions("itemLabel"));
    i0.ɵɵattribute("data-pc-section", "itemlabel");
  }
}
function MenuItemContent_ng_template_3_p_badge_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-badge", 15);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("styleClass", ctx_r0.item.badgeStyleClass)("value", ctx_r0.item.badge)("pt", ctx_r0.getPTOptions("pcBadge"))("unstyled", ctx_r0.unstyled());
  }
}
function MenuItemContent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemContent_ng_template_3_span_0_Template, 1, 7, "span", 9)(1, MenuItemContent_ng_template_3_span_1_Template, 2, 6, "span", 10)(2, MenuItemContent_ng_template_3_ng_template_2_Template, 2, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, MenuItemContent_ng_template_3_p_badge_4_Template, 1, 4, "p-badge", 11);
  }
  if (rf & 2) {
    const htmlLabel_r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.item.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.escape !== false)("ngIfElse", htmlLabel_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.item.badge);
  }
}
const _c4 = ["start"];
const _c5 = ["end"];
const _c6 = ["header"];
const _c7 = ["item"];
const _c8 = ["submenuheader"];
const _c9 = ["list"];
const _c10 = ["container"];
const _c11 = (a0, a1) => ({
  item: a0,
  id: a1
});
function Menu_Conditional_0_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Menu_Conditional_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, Menu_Conditional_0_div_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.cx("start"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("start"));
    i0.ɵɵattribute("data-pc-section", "start");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.startTemplate ?? ctx_r1._startTemplate);
  }
}
function Menu_Conditional_0_5_ng_template_0_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.cx("separator"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("separator"));
    i0.ɵɵattribute("data-pc-section", "separator");
  }
}
function Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const submenu_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(submenu_r3.label);
  }
}
function Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const submenu_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, submenu_r3.label), i0.ɵɵsanitizeHtml);
  }
}
function Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_span_1_Template, 2, 1, "span", 16)(2, Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_ng_template_2_Template, 2, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const htmlSubmenuLabel_r4 = i0.ɵɵreference(3);
    const submenu_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", submenu_r3.escape !== false)("ngIfElse", htmlSubmenuLabel_r4);
  }
}
function Menu_Conditional_0_5_ng_template_0_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Menu_Conditional_0_5_ng_template_0_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 14);
    i0.ɵɵtemplate(1, Menu_Conditional_0_5_ng_template_0_li_1_ng_container_1_Template, 4, 2, "ng-container", 7)(2, Menu_Conditional_0_5_ng_template_0_li_1_ng_container_2_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const submenu_r3 = ctx_r4.$implicit;
    const i_r6 = ctx_r4.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.cx("submenuLabel"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("submenuLabel"))("tooltipOptions", submenu_r3.tooltipOptions)("pTooltipUnstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("data-automationid", submenu_r3.automationId)("id", ctx_r1.menuitemId(submenu_r3, ctx_r1.id, i_r6))("data-pc-section", "submenulabel");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.submenuHeaderTemplate && !ctx_r1._submenuHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.submenuHeaderTemplate ?? ctx_r1._submenuHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c1, submenu_r3));
  }
}
function Menu_Conditional_0_5_ng_template_0_ng_template_2_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap(ctx_r1.cx("separator"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("separator"));
    i0.ɵɵattribute("data-pc-section", "separator");
  }
}
function Menu_Conditional_0_5_ng_template_0_ng_template_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19);
    i0.ɵɵlistener("onMenuItemClick", function Menu_Conditional_0_5_ng_template_0_ng_template_2_li_1_Template_li_onMenuItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r7 = i0.ɵɵnextContext();
      const item_r9 = ctx_r7.$implicit;
      const j_r10 = ctx_r7.index;
      const i_r6 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemClick($event, ctx_r1.menuitemId(item_r9, ctx_r1.id, i_r6, j_r10)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const j_r10 = ctx_r7.index;
    const i_r6 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleMap(item_r9.style);
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("item", i0.ɵɵpureFunction2(17, _c11, item_r9, ctx_r1.menuitemId(item_r9, ctx_r1.id, i_r6, j_r10))), item_r9 == null ? null : item_r9.styleClass));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("item"))("pMenuItemContent", item_r9)("itemTemplate", ctx_r1.itemTemplate ?? ctx_r1._itemTemplate)("idx", j_r10)("menuitemId", ctx_r1.menuitemId(item_r9, ctx_r1.id, i_r6, j_r10))("tooltipOptions", item_r9.tooltipOptions)("pTooltipUnstyled", ctx_r1.unstyled())("unstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("aria-label", ctx_r1.label(item_r9.label))("data-p-focused", ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r9, ctx_r1.id, i_r6, j_r10)))("data-p-disabled", ctx_r1.disabled(item_r9.disabled))("aria-disabled", ctx_r1.disabled(item_r9.disabled))("id", ctx_r1.menuitemId(item_r9, ctx_r1.id, i_r6, j_r10));
  }
}
function Menu_Conditional_0_5_ng_template_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Menu_Conditional_0_5_ng_template_0_ng_template_2_li_0_Template, 1, 4, "li", 11)(1, Menu_Conditional_0_5_ng_template_0_ng_template_2_li_1_Template, 1, 20, "li", 18);
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const submenu_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", item_r9.separator && (item_r9.visible !== false || submenu_r3.visible !== false));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r9.separator && item_r9.visible !== false && (item_r9.visible !== undefined || submenu_r3.visible !== false));
  }
}
function Menu_Conditional_0_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Menu_Conditional_0_5_ng_template_0_li_0_Template, 1, 4, "li", 11)(1, Menu_Conditional_0_5_ng_template_0_li_1_Template, 3, 13, "li", 12)(2, Menu_Conditional_0_5_ng_template_0_ng_template_2_Template, 2, 2, "ng-template", 10);
  }
  if (rf & 2) {
    const submenu_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", submenu_r3.separator && submenu_r3.visible !== false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !submenu_r3.separator);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", submenu_r3.items);
  }
}
function Menu_Conditional_0_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Menu_Conditional_0_5_ng_template_0_Template, 3, 3, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.model);
  }
}
function Menu_Conditional_0_6_ng_template_0_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.cx("separator"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("separator"));
    i0.ɵɵattribute("data-pc-section", "separator");
  }
}
function Menu_Conditional_0_6_ng_template_0_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 21);
    i0.ɵɵlistener("onMenuItemClick", function Menu_Conditional_0_6_ng_template_0_li_1_Template_li_onMenuItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r11 = i0.ɵɵnextContext();
      const item_r13 = ctx_r11.$implicit;
      const i_r14 = ctx_r11.index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemClick($event, ctx_r1.menuitemId(item_r13, ctx_r1.id, i_r14)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const item_r13 = ctx_r11.$implicit;
    const i_r14 = ctx_r11.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("item", i0.ɵɵpureFunction2(16, _c11, item_r13, ctx_r1.menuitemId(item_r13, ctx_r1.id, i_r14))), item_r13 == null ? null : item_r13.styleClass));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("item"))("pMenuItemContent", item_r13)("itemTemplate", ctx_r1.itemTemplate ?? ctx_r1._itemTemplate)("idx", i_r14)("menuitemId", ctx_r1.menuitemId(item_r13, ctx_r1.id, i_r14))("ngStyle", item_r13.style)("tooltipOptions", item_r13.tooltipOptions)("unstyled", ctx_r1.unstyled())("pTooltipUnstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("aria-label", ctx_r1.label(item_r13.label))("data-p-focused", ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r13, ctx_r1.id, i_r14)))("data-p-disabled", ctx_r1.disabled(item_r13.disabled))("aria-disabled", ctx_r1.disabled(item_r13.disabled))("id", ctx_r1.menuitemId(item_r13, ctx_r1.id, i_r14));
  }
}
function Menu_Conditional_0_6_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Menu_Conditional_0_6_ng_template_0_li_0_Template, 1, 4, "li", 11)(1, Menu_Conditional_0_6_ng_template_0_li_1_Template, 1, 19, "li", 20);
  }
  if (rf & 2) {
    const item_r13 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r13.separator && item_r13.visible !== false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r13.separator && item_r13.visible !== false);
  }
}
function Menu_Conditional_0_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Menu_Conditional_0_6_ng_template_0_Template, 2, 2, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.model);
  }
}
function Menu_Conditional_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Menu_Conditional_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, Menu_Conditional_0_div_7_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.cx("end"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("end"));
    i0.ɵɵattribute("data-pc-section", "end");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.endTemplate ?? ctx_r1._endTemplate);
  }
}
function Menu_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 0);
    i0.ɵɵlistener("click", function Menu_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayClick($event));
    })("pMotionOnBeforeEnter", function Menu_Conditional_0_Template_div_pMotionOnBeforeEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayBeforeEnter($event));
    })("pMotionOnAfterLeave", function Menu_Conditional_0_Template_div_pMotionOnAfterLeave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayAfterLeave());
    });
    i0.ɵɵtemplate(2, Menu_Conditional_0_div_2_Template, 2, 5, "div", 5);
    i0.ɵɵelementStart(3, "ul", 6, 1);
    i0.ɵɵlistener("focus", function Menu_Conditional_0_Template_ul_focus_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListFocus($event));
    })("blur", function Menu_Conditional_0_Template_ul_blur_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListBlur($event));
    })("keydown", function Menu_Conditional_0_Template_ul_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListKeyDown($event));
    });
    i0.ɵɵtemplate(5, Menu_Conditional_0_5_Template, 1, 1, null, 7)(6, Menu_Conditional_0_6_Template, 1, 1, null, 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, Menu_Conditional_0_div_7_Template, 2, 5, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.sx("root"));
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("root"), ctx_r1.styleClass));
    i0.ɵɵproperty("ngStyle", ctx_r1.style)("pBind", ctx_r1.ptm("root"))("pMotion", ctx_r1.visible || !ctx_r1.popup)("pMotionName", "p-anchored-overlay")("pMotionAppear", !!ctx_r1.popup)("pMotionDisabled", !ctx_r1.popup)("pMotionOptions", ctx_r1.computedMotionOptions());
    i0.ɵɵattribute("id", ctx_r1.id)("data-p", ctx_r1.dataP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.startTemplate ?? ctx_r1._startTemplate);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.cx("list"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("list"));
    i0.ɵɵattribute("id", ctx_r1.id + "_list")("tabindex", ctx_r1.getTabIndexValue())("data-pc-section", "menu")("aria-activedescendant", ctx_r1.activedescendant())("aria-label", ctx_r1.ariaLabel)("aria-labelledBy", ctx_r1.ariaLabelledBy);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasSubMenu());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.hasSubMenu());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.endTemplate ?? ctx_r1._endTemplate);
  }
}
export * from 'primeng/types/menu';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, PLATFORM_ID, Inject, Pipe, input, EventEmitter, inject, forwardRef, Output, Input, ViewEncapsulation, Component, computed, viewChild, signal, numberAttribute, booleanAttribute, ContentChildren, ContentChild, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import { uuid, addStyle, absolutePosition, focus, appendChild, isTouchDevice, find, findSingle } from '@primeuix/utils';
import * as i6 from 'primeng/api';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import * as i5 from 'primeng/badge';
import { BadgeModule } from 'primeng/badge';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i4 from 'primeng/bind';
import { BindModule, Bind } from 'primeng/bind';
import { ConnectedOverlayScrollHandler } from 'primeng/dom';
import * as i8 from 'primeng/motion';
import { MotionModule } from 'primeng/motion';
import { Ripple } from 'primeng/ripple';
import * as i7 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import { ZIndexUtils } from 'primeng/utils';
import { style } from '@primeuix/styles/menu';
import { BaseStyle } from 'primeng/base';
import * as i1 from '@angular/platform-browser';
const inlineStyles = {
  root: ({
    instance
  }) => ({
    position: instance.popup ? 'absolute' : 'relative'
  })
};
const classes = {
  root: ({
    instance
  }) => ['p-menu p-component', {
    'p-menu-overlay': instance.popup
  }],
  start: 'p-menu-start',
  list: 'p-menu-list',
  submenuLabel: 'p-menu-submenu-label',
  separator: 'p-menu-separator',
  end: 'p-menu-end',
  item: ({
    instance,
    item,
    id
  }) => ['p-menu-item', {
    'p-focus': instance.focusedOptionId() && id === instance.focusedOptionId(),
    'p-disabled': instance.disabled(item.disabled)
  }, item.styleClass],
  itemContent: 'p-menu-item-content',
  itemLink: 'p-menu-item-link',
  itemIcon: ({
    item
  }) => ['p-menu-item-icon', item.icon, item.iconClass],
  itemLabel: 'p-menu-item-label'
};
let MenuStyle = /*#__PURE__*/(() => {
  class MenuStyle extends BaseStyle {
    name = 'menu';
    style = style;
    classes = classes;
    inlineStyles = inlineStyles;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMenuStyle_BaseFactory;
      return function MenuStyle_Factory(__ngFactoryType__) {
        return (ɵMenuStyle_BaseFactory || (ɵMenuStyle_BaseFactory = i0.ɵɵgetInheritedFactory(MenuStyle)))(__ngFactoryType__ || MenuStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MenuStyle,
      factory: MenuStyle.ɵfac
    });
  }
  return MenuStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Menu is a navigation / command component that supports dynamic and static positioning.
 *
 * [Live Demo](https://www.primeng.org/menu/)
 *
 * @module menustyle
 *
 */
var MenuClasses = /*#__PURE__*/function (MenuClasses) {
  /**
   * Class name of the root element
   */
  MenuClasses["root"] = "p-menu";
  /**
   * Class name of the start element
   */
  MenuClasses["start"] = "p-menu-start";
  /**
   * Class name of the list element
   */
  MenuClasses["list"] = "p-menu-list";
  /**
   * Class name of the submenu item element
   */
  MenuClasses["submenuItem"] = "p-menu-submenu-item";
  /**
   * Class name of the separator element
   */
  MenuClasses["separator"] = "p-menu-separator";
  /**
   * Class name of the end element
   */
  MenuClasses["end"] = "p-menu-end";
  /**
   * Class name of the item element
   */
  MenuClasses["item"] = "p-menu-item";
  /**
   * Class name of the item content element
   */
  MenuClasses["itemContent"] = "p-menu-item-content";
  /**
   * Class name of the item link element
   */
  MenuClasses["itemLink"] = "p-menu-item-link";
  /**
   * Class name of the item icon element
   */
  MenuClasses["itemIcon"] = "p-menu-item-icon";
  /**
   * Class name of the item label element
   */
  MenuClasses["itemLabel"] = "p-menu-item-label";
  return MenuClasses;
}(MenuClasses || {});
const MENU_INSTANCE = /*#__PURE__*/new InjectionToken('MENU_INSTANCE');
let SafeHtmlPipe = /*#__PURE__*/(() => {
  class SafeHtmlPipe {
    platformId;
    sanitizer;
    constructor(platformId, sanitizer) {
      this.platformId = platformId;
      this.sanitizer = sanitizer;
    }
    transform(value) {
      if (!value || !isPlatformBrowser(this.platformId)) {
        return value;
      }
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    static ɵfac = function SafeHtmlPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SafeHtmlPipe)(i0.ɵɵdirectiveInject(PLATFORM_ID, 16), i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "safeHtml",
      type: SafeHtmlPipe,
      pure: true
    });
  }
  return SafeHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MenuItemContent = /*#__PURE__*/(() => {
  class MenuItemContent extends BaseComponent {
    item;
    itemTemplate;
    menuitemId = input('', ...(ngDevMode ? [{
      debugName: "menuitemId"
    }] : []));
    idx = input(0, ...(ngDevMode ? [{
      debugName: "idx"
    }] : []));
    onMenuItemClick = new EventEmitter();
    menu;
    _componentStyle = inject(MenuStyle);
    hostName = 'Menu';
    constructor(menu) {
      super();
      this.menu = menu;
    }
    onItemClick(event, item) {
      this.onMenuItemClick.emit({
        originalEvent: event,
        item
      });
    }
    getPTOptions(key) {
      return this.menu.getPTOptions(key, this.item, this.idx(), this.menuitemId());
    }
    static ɵfac = function MenuItemContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MenuItemContent)(i0.ɵɵdirectiveInject(forwardRef(() => Menu)));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MenuItemContent,
      selectors: [["", "pMenuItemContent", ""]],
      inputs: {
        item: [0, "pMenuItemContent", "item"],
        itemTemplate: "itemTemplate",
        menuitemId: [1, "menuitemId"],
        idx: [1, "idx"]
      },
      outputs: {
        onMenuItemClick: "onMenuItemClick"
      },
      features: [i0.ɵɵProvidersFeature([MenuStyle]), i0.ɵɵInheritDefinitionFeature],
      attrs: _c0,
      decls: 5,
      vars: 6,
      consts: [["itemContent", ""], ["htmlLabel", ""], [3, "click", "pBind"], [4, "ngIf"], ["pRipple", "", 3, "class", "ngStyle", "target", "pBind", 4, "ngIf"], ["routerLinkActive", "p-menu-item-link-active", "pRipple", "", 3, "routerLink", "queryParams", "routerLinkActiveOptions", "class", "ngStyle", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind", 4, "ngIf"], ["pRipple", "", 3, "ngStyle", "target", "pBind"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["routerLinkActive", "p-menu-item-link-active", "pRipple", "", 3, "routerLink", "queryParams", "routerLinkActiveOptions", "ngStyle", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "pBind"], [3, "class", "pBind", "ngStyle", 4, "ngIf"], [3, "class", "ngStyle", "pBind", 4, "ngIf", "ngIfElse"], [3, "styleClass", "value", "pt", "unstyled", 4, "ngIf"], [3, "pBind", "ngStyle"], [3, "ngStyle", "pBind"], [3, "ngStyle", "innerHTML", "pBind"], [3, "styleClass", "value", "pt", "unstyled"]],
      template: function MenuItemContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("click", function MenuItemContent_Template_div_click_0_listener($event) {
            return ctx.onItemClick($event, ctx.item);
          });
          i0.ɵɵtemplate(1, MenuItemContent_ng_container_1_Template, 3, 2, "ng-container", 3)(2, MenuItemContent_ng_container_2_Template, 2, 4, "ng-container", 3)(3, MenuItemContent_ng_template_3_Template, 5, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cx("itemContent"));
          i0.ɵɵproperty("pBind", ctx.getPTOptions("itemContent"));
          i0.ɵɵattribute("data-pc-section", "content");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.itemTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.itemTemplate);
        }
      },
      dependencies: [CommonModule, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, RouterModule, i3.RouterLink, i3.RouterLinkActive, Ripple, TooltipModule, i4.Bind, BadgeModule, i5.Badge, SharedModule, BindModule, SafeHtmlPipe],
      encapsulation: 2
    });
  }
  return MenuItemContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Menu is a navigation / command component that supports dynamic and static positioning.
 * @group Components
 */
let Menu = /*#__PURE__*/(() => {
  class Menu extends BaseComponent {
    overlayService;
    componentName = 'Menu';
    /**
     * An array of menuitems.
     * @group Props
     */
    model;
    /**
     * Defines if menu would displayed as a popup.
     * @group Props
     */
    popup;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Whether to automatically manage layering.
     * @group Props
     */
    autoZIndex = true;
    /**
     * Base zIndex value to use in layering.
     * @group Props
     */
    baseZIndex = 0;
    /**
     * Transition options of the show animation.
     * @deprecated since v21.0.0, use `motionOptions` instead.
     * @group Props
     */
    showTransitionOptions = '.12s cubic-bezier(0, 0, 0.2, 1)';
    /**
     * Transition options of the hide animation.
     * @deprecated since v21.0.0, use `motionOptions` instead.
     * @group Props
     */
    hideTransitionOptions = '.1s linear';
    /**
     * Defines a string value that labels an interactive element.
     * @group Props
     */
    ariaLabel;
    /**
     * Identifier of the underlying input element.
     * @group Props
     */
    ariaLabelledBy;
    /**
     * Current id state as a string.
     * @group Props
     */
    id;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex = 0;
    /**
     * Target element to attach the overlay, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name).
     * @defaultValue 'self'
     * @group Props
     */
    appendTo = input(undefined, ...(ngDevMode ? [{
      debugName: "appendTo"
    }] : []));
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Callback to invoke when overlay menu is shown.
     * @group Emits
     */
    onShow = new EventEmitter();
    /**
     * Callback to invoke when overlay menu is hidden.
     * @group Emits
     */
    onHide = new EventEmitter();
    /**
     * Callback to invoke when the list loses focus.
     * @param {Event} event - blur event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    /**
     * Callback to invoke when the list receives focus.
     * @param {Event} event - focus event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    listViewChild = viewChild('list', ...(ngDevMode ? [{
      debugName: "listViewChild"
    }] : []));
    containerViewChild = viewChild('container', ...(ngDevMode ? [{
      debugName: "containerViewChild"
    }] : []));
    $appendTo = computed(() => this.appendTo() || this.config.overlayAppendTo(), ...(ngDevMode ? [{
      debugName: "$appendTo"
    }] : []));
    container;
    scrollHandler;
    documentClickListener;
    documentResizeListener;
    preventDocumentDefault;
    target;
    visible;
    focusedOptionId = computed(() => {
      return this.focusedOptionIndex() !== -1 ? this.focusedOptionIndex() : null;
    }, ...(ngDevMode ? [{
      debugName: "focusedOptionId"
    }] : []));
    focusedOptionIndex = signal(-1, ...(ngDevMode ? [{
      debugName: "focusedOptionIndex"
    }] : []));
    selectedOptionIndex = signal(-1, ...(ngDevMode ? [{
      debugName: "selectedOptionIndex"
    }] : []));
    focused = false;
    overlayVisible = false;
    $pcMenu = inject(MENU_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    _componentStyle = inject(MenuStyle);
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm('host'));
    }
    constructor(overlayService) {
      super();
      this.overlayService = overlayService;
      this.id = this.id || uuid('pn_id_');
    }
    getPTOptions(key, item, index, id) {
      return this.ptm(key, {
        context: {
          item: item,
          index: index,
          focused: this.isItemFocused(id),
          disabled: this.disabled(item.disabled)
        }
      });
    }
    /**
     * Toggles the visibility of the popup menu.
     * @param {Event} event - Browser event.
     * @group Method
     */
    toggle(event) {
      if (this.visible) this.hide();else this.show(event);
      this.preventDocumentDefault = true;
    }
    /**
     * Displays the popup menu.
     * @param {Event} event - Browser event.
     * @group Method
     */
    show(event) {
      // Clear container if exists but overlay is not currently visible (fast toggle case)
      if (this.container && !this.overlayVisible) {
        this.container = undefined;
      }
      this.target = event.currentTarget;
      this.visible = true;
      this.preventDocumentDefault = true;
      this.overlayVisible = true;
      this.cd.markForCheck();
    }
    onInit() {
      if (!this.popup) {
        this.bindDocumentClickListener();
      }
    }
    /**
     * Defines template option for start.
     * @group Templates
     */
    startTemplate;
    _startTemplate;
    /**
     * Defines template option for end.
     * @group Templates
     */
    endTemplate;
    _endTemplate;
    /**
     * Defines template option for header.
     * @group Templates
     */
    headerTemplate;
    _headerTemplate;
    /**
     * Custom item template.
     * @param {MenuItemTemplateContext} context - item context.
     * @see {@link MenuItemTemplateContext}
     * @group Templates
     */
    itemTemplate;
    _itemTemplate;
    /**
     * Custom submenu header template.
     * @param {MenuSubmenuHeaderTemplateContext} context - submenu header context.
     * @see {@link MenuSubmenuHeaderTemplateContext}
     * @group Templates
     */
    submenuHeaderTemplate;
    _submenuHeaderTemplate;
    templates;
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'start':
            this._startTemplate = item.template;
            break;
          case 'end':
            this._endTemplate = item.template;
            break;
          case 'item':
            this._itemTemplate = item.template;
            break;
          case 'submenuheader':
            this._submenuHeaderTemplate = item.template;
            break;
          default:
            this._itemTemplate = item.template;
            break;
        }
      });
    }
    getTabIndexValue() {
      return this.tabindex !== undefined ? this.tabindex.toString() : null;
    }
    onOverlayBeforeEnter(event) {
      this.container = event.element;
      if (this.container) {
        addStyle(this.container, {
          position: 'absolute',
          top: '0'
        });
        this.appendOverlay();
        this.moveOnTop();
        this.$attrSelector && this.container?.setAttribute(this.$attrSelector, '');
        this.bindDocumentClickListener();
        this.bindDocumentResizeListener();
        this.bindScrollListener();
        absolutePosition(this.container, this.target);
        focus(this.listViewChild()?.nativeElement);
        this.onShow.emit({});
      }
    }
    onOverlayAfterLeave() {
      this.restoreOverlayAppend();
      this.onOverlayHide();
      this.overlayVisible = false;
      this.onHide.emit({});
    }
    appendOverlay() {
      if (this.$appendTo() && this.$appendTo() !== 'self') {
        if (this.$appendTo() === 'body') {
          appendChild(this.document.body, this.container);
        } else {
          appendChild(this.$appendTo(), this.container);
        }
      }
    }
    restoreOverlayAppend() {
      if (this.container && this.$appendTo() !== 'self') {
        appendChild(this.el.nativeElement, this.container);
      }
    }
    moveOnTop() {
      if (this.autoZIndex) {
        ZIndexUtils.set('menu', this.container, this.baseZIndex + this.config.zIndex.menu);
      }
    }
    /**
     * Hides the popup menu.
     * @group Method
     */
    hide() {
      this.visible = false;
      this.cd.markForCheck();
    }
    onWindowResize() {
      if (this.visible && !isTouchDevice()) {
        this.hide();
      }
    }
    menuitemId(item, id, index, childIndex) {
      return item?.id ?? `${id}_${index}${childIndex !== undefined ? '_' + childIndex : ''}`;
    }
    isItemFocused(id) {
      return this.focusedOptionId() === id;
    }
    label(label) {
      return typeof label === 'function' ? label() : label;
    }
    disabled(disabled) {
      return typeof disabled === 'function' ? disabled() : typeof disabled === 'undefined' ? false : disabled;
    }
    activedescendant() {
      return this.focused ? this.focusedOptionId() : undefined;
    }
    onListFocus(event) {
      if (!this.focused) {
        this.focused = true;
        !this.popup && this.changeFocusedOptionIndex(0);
        this.onFocus.emit(event);
      }
    }
    onListBlur(event) {
      if (this.focused) {
        this.focused = false;
        this.changeFocusedOptionIndex(-1);
        this.selectedOptionIndex.set(-1);
        this.focusedOptionIndex.set(-1);
        this.onBlur.emit(event);
      }
    }
    onListKeyDown(event) {
      switch (event.code) {
        case 'ArrowDown':
          this.onArrowDownKey(event);
          break;
        case 'ArrowUp':
          this.onArrowUpKey(event);
          break;
        case 'Home':
          this.onHomeKey(event);
          break;
        case 'End':
          this.onEndKey(event);
          break;
        case 'Enter':
          this.onEnterKey(event);
          break;
        case 'NumpadEnter':
          this.onEnterKey(event);
          break;
        case 'Space':
          this.onSpaceKey(event);
          break;
        case 'Escape':
        case 'Tab':
          if (this.popup) {
            focus(this.target);
            this.hide();
          }
          this.overlayVisible && this.hide();
          break;
        default:
          break;
      }
    }
    onArrowDownKey(event) {
      const optionIndex = this.findNextOptionIndex(this.focusedOptionIndex());
      this.changeFocusedOptionIndex(optionIndex);
      event.preventDefault();
    }
    onArrowUpKey(event) {
      if (event.altKey && this.popup) {
        focus(this.target);
        this.hide();
        event.preventDefault();
      } else {
        const optionIndex = this.findPrevOptionIndex(this.focusedOptionIndex());
        this.changeFocusedOptionIndex(optionIndex);
        event.preventDefault();
      }
    }
    onHomeKey(event) {
      this.changeFocusedOptionIndex(0);
      event.preventDefault();
    }
    onEndKey(event) {
      this.changeFocusedOptionIndex(find(this.containerViewChild()?.nativeElement, 'li[data-pc-section="item"][data-p-disabled="false"]').length - 1);
      event.preventDefault();
    }
    onEnterKey(event) {
      const element = findSingle(this.containerViewChild()?.nativeElement, `li[id="${`${this.focusedOptionIndex()}`}"]`);
      const anchorElement = element && (findSingle(element, '[data-pc-section="itemlink"]') || findSingle(element, 'a,button'));
      this.popup && focus(this.target);
      anchorElement ? anchorElement.click() : element && element.click();
      event.preventDefault();
    }
    onSpaceKey(event) {
      this.onEnterKey(event);
    }
    findNextOptionIndex(index) {
      const links = find(this.containerViewChild()?.nativeElement, 'li[data-pc-section="item"][data-p-disabled="false"]');
      const matchedOptionIndex = [...links].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex + 1 : 0;
    }
    findPrevOptionIndex(index) {
      const links = find(this.containerViewChild()?.nativeElement, 'li[data-pc-section="item"][data-p-disabled="false"]');
      const matchedOptionIndex = [...links].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex - 1 : 0;
    }
    changeFocusedOptionIndex(index) {
      const links = find(this.containerViewChild()?.nativeElement, 'li[data-pc-section="item"][data-p-disabled="false"]');
      if (links.length > 0) {
        let order = index >= links.length ? links.length - 1 : index < 0 ? 0 : index;
        order > -1 && this.focusedOptionIndex.set(links[order].getAttribute('id'));
      }
    }
    itemClick(event, id) {
      const {
        originalEvent,
        item
      } = event;
      if (!this.focused) {
        this.focused = true;
        this.onFocus.emit();
      }
      if (item.disabled) {
        originalEvent.preventDefault();
        return;
      }
      if (!item.url && !item.routerLink) {
        originalEvent.preventDefault();
      }
      if (item.command) {
        item.command({
          originalEvent: originalEvent,
          item: item
        });
      }
      if (this.popup) {
        this.hide();
      }
      if (!this.popup && this.focusedOptionIndex() !== id) {
        this.focusedOptionIndex.set(id);
      }
    }
    onOverlayClick(event) {
      if (this.popup) {
        this.overlayService.add({
          originalEvent: event,
          target: this.el.nativeElement
        });
      }
      this.preventDocumentDefault = true;
    }
    bindDocumentClickListener() {
      if (!this.documentClickListener && isPlatformBrowser(this.platformId)) {
        const documentTarget = this.el ? this.el.nativeElement.ownerDocument : 'document';
        this.documentClickListener = this.renderer.listen(documentTarget, 'click', event => {
          const isOutsideContainer = this.containerViewChild()?.nativeElement && !this.containerViewChild()?.nativeElement.contains(event.target);
          const isOutsideTarget = !(this.target && (this.target === event.target || this.target.contains(event.target)));
          if (!this.popup && isOutsideContainer && isOutsideTarget) {
            this.onListBlur(event);
          }
          if (this.preventDocumentDefault && this.overlayVisible && isOutsideContainer && isOutsideTarget) {
            this.hide();
            this.preventDocumentDefault = false;
          }
        });
      }
    }
    unbindDocumentClickListener() {
      if (this.documentClickListener) {
        this.documentClickListener();
        this.documentClickListener = null;
      }
    }
    bindDocumentResizeListener() {
      if (!this.documentResizeListener && isPlatformBrowser(this.platformId)) {
        const window = this.document.defaultView;
        this.documentResizeListener = this.renderer.listen(window, 'resize', this.onWindowResize.bind(this));
      }
    }
    unbindDocumentResizeListener() {
      if (this.documentResizeListener) {
        this.documentResizeListener();
        this.documentResizeListener = null;
      }
    }
    bindScrollListener() {
      if (!this.scrollHandler && isPlatformBrowser(this.platformId)) {
        this.scrollHandler = new ConnectedOverlayScrollHandler(this.target, () => {
          if (this.visible) {
            this.hide();
          }
        });
      }
      this.scrollHandler?.bindScrollListener();
    }
    unbindScrollListener() {
      if (this.scrollHandler) {
        this.scrollHandler.unbindScrollListener();
        this.scrollHandler = null;
      }
    }
    onOverlayHide() {
      this.unbindDocumentClickListener();
      this.unbindDocumentResizeListener();
      this.unbindScrollListener();
      this.preventDocumentDefault = false;
      if (!this.cd.destroyed) {
        this.target = null;
      }
      if (this.container) {
        if (this.autoZIndex) {
          ZIndexUtils.clear(this.container);
        }
        this.container = undefined;
      }
    }
    onDestroy() {
      if (this.popup) {
        if (this.scrollHandler) {
          this.scrollHandler.destroy();
          this.scrollHandler = null;
        }
        if (this.container) {
          if (this.autoZIndex) {
            ZIndexUtils.clear(this.container);
          }
          this.container = undefined;
        }
        this.restoreOverlayAppend();
        this.onOverlayHide();
      }
      if (!this.popup) {
        this.unbindDocumentClickListener();
      }
    }
    hasSubMenu() {
      return this.model?.some(item => item.items) ?? false;
    }
    isItemHidden(item) {
      if (item.separator) {
        return item.visible === false || item.items && item.items.some(subitem => subitem.visible !== false);
      }
      return item.visible === false;
    }
    get dataP() {
      return this.cn({
        popup: this.popup
      });
    }
    static ɵfac = function Menu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Menu)(i0.ɵɵdirectiveInject(i6.OverlayService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Menu,
      selectors: [["p-menu"]],
      contentQueries: function Menu_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c4, 4)(dirIndex, _c5, 4)(dirIndex, _c6, 4)(dirIndex, _c7, 4)(dirIndex, _c8, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submenuHeaderTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Menu_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.listViewChild, _c9, 5)(ctx.containerViewChild, _c10, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      inputs: {
        model: "model",
        popup: [2, "popup", "popup", booleanAttribute],
        style: "style",
        styleClass: "styleClass",
        autoZIndex: [2, "autoZIndex", "autoZIndex", booleanAttribute],
        baseZIndex: [2, "baseZIndex", "baseZIndex", numberAttribute],
        showTransitionOptions: "showTransitionOptions",
        hideTransitionOptions: "hideTransitionOptions",
        ariaLabel: "ariaLabel",
        ariaLabelledBy: "ariaLabelledBy",
        id: "id",
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        appendTo: [1, "appendTo"],
        motionOptions: [1, "motionOptions"]
      },
      outputs: {
        onShow: "onShow",
        onHide: "onHide",
        onBlur: "onBlur",
        onFocus: "onFocus"
      },
      features: [i0.ɵɵProvidersFeature([MenuStyle, {
        provide: MENU_INSTANCE,
        useExisting: Menu
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Menu
      }]), i0.ɵɵHostDirectivesFeature([i4.Bind]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["container", ""], ["list", ""], ["htmlSubmenuLabel", ""], [3, "class", "style", "ngStyle", "pBind", "pMotion", "pMotionName", "pMotionAppear", "pMotionDisabled", "pMotionOptions"], [3, "click", "pMotionOnBeforeEnter", "pMotionOnAfterLeave", "ngStyle", "pBind", "pMotion", "pMotionName", "pMotionAppear", "pMotionDisabled", "pMotionOptions"], [3, "class", "pBind", 4, "ngIf"], ["role", "menu", 3, "focus", "blur", "keydown", "pBind"], [4, "ngIf"], [3, "pBind"], [4, "ngTemplateOutlet"], ["ngFor", "", 3, "ngForOf"], ["role", "separator", 3, "class", "pBind", 4, "ngIf"], ["pTooltip", "", "role", "none", 3, "class", "pBind", "tooltipOptions", "pTooltipUnstyled", 4, "ngIf"], ["role", "separator", 3, "pBind"], ["pTooltip", "", "role", "none", 3, "pBind", "tooltipOptions", "pTooltipUnstyled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf", "ngIfElse"], [3, "innerHTML"], ["pTooltip", "", "role", "menuitem", 3, "class", "pBind", "pMenuItemContent", "itemTemplate", "idx", "menuitemId", "style", "tooltipOptions", "pTooltipUnstyled", "unstyled", "onMenuItemClick", 4, "ngIf"], ["pTooltip", "", "role", "menuitem", 3, "onMenuItemClick", "pBind", "pMenuItemContent", "itemTemplate", "idx", "menuitemId", "tooltipOptions", "pTooltipUnstyled", "unstyled"], ["pTooltip", "", "role", "menuitem", 3, "class", "pBind", "pMenuItemContent", "itemTemplate", "idx", "menuitemId", "ngStyle", "tooltipOptions", "unstyled", "pTooltipUnstyled", "onMenuItemClick", 4, "ngIf"], ["pTooltip", "", "role", "menuitem", 3, "onMenuItemClick", "pBind", "pMenuItemContent", "itemTemplate", "idx", "menuitemId", "ngStyle", "tooltipOptions", "unstyled", "pTooltipUnstyled"]],
      template: function Menu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, Menu_Conditional_0_Template, 8, 26, "div", 3);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.popup || ctx.overlayVisible ? 0 : -1);
        }
      },
      dependencies: [CommonModule, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, RouterModule, MenuItemContent, TooltipModule, i7.Tooltip, i4.Bind, BadgeModule, SharedModule, BindModule, MotionModule, i8.MotionDirective, SafeHtmlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Menu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MenuModule = /*#__PURE__*/(() => {
  class MenuModule {
    static ɵfac = function MenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MenuModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MenuModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Menu, SharedModule, SharedModule]
    });
  }
  return MenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Menu, MenuClasses, MenuItemContent, MenuModule, MenuStyle, SafeHtmlPipe };
